<template>
  <div v-bind:id="id" class="member-place-option-menu">
    <b-button
      v-bind:id="buttonId"
      class="action-btn menu-btn"
      size="sm"
      variant="light"
      v-on:mouseenter="isTooltipShow = true"
      v-on:mouseleave="isTooltipShow = false"
      v-on:click="isMenuShow = !isMenuShow"
    >
      <menu-button-icon class="icon" />
    </b-button>
    <!-- 名称ツールチップ -->
    <b-tooltip
      v-bind:target="buttonId"
      interactive="false"
      triggers="manual"
      placement="bottom"
      boundary="window"
      custom-class="ifield-tooltip"
      v-bind:title="$t('appMemberPlaceOptionMenu.optionMenu')"
      v-bind:show="!isMenuShow && isTooltipShow"
    />
    <!-- メニューポップアップ -->
    <b-tooltip
      v-bind:target="buttonId"
      v-bind:triggers="['click', !isItemSelectorShow && 'blur']"
      variant="light"
      placement="bottomright"
      boundary="window"
      custom-class="menu-popup"
      v-bind:show="isMenuShow"
      v-bind:offset="menuOffset"
      v-on:show="isTooltipShow = false"
      v-on:hide="isMenuShow = false"
    >
      <member-place-menu-item-additional-item-selector
        v-bind:items="additionalItems"
        v-bind:is-simple="isSimple"
        v-on:items-changed="(value) => $emit('items-changed', value)"
        v-on:is-simple-changed="(value) => $emit('is-simple-changed', value)"
        v-on:show-item-selector="isItemSelectorShow = true"
        v-on:hide-item-selector="
          () => {
            isMenuShow = false
            isItemSelectorShow = false
          }
        "
      />
    </b-tooltip>
  </div>
</template>

<script>
import MenuButtonIcon from '@/assets/ifield/ic_menu_dot.svg?component'
import MemberPlaceMenuItemAdditionalItemSelector from '@/components/member/AppMemberPlaceMenuItemAdditionalItemSelector.vue'

/**
 * 地図画面のプレイスタブのオプションメニュー
 *
 * 表示設定（簡易表示・任意項目の選択）を出す。IFIELD_V4-7150。
 * ユーザーリストの `AppMemberUserOptionMenu.vue` と同じ作りにしてある
 */
export default {
  name: 'AppMemberPlaceOptionMenu',
  components: {
    MenuButtonIcon,
    MemberPlaceMenuItemAdditionalItemSelector,
  },
  props: {
    /**
     * ルート要素のID
     * 子要素のIDのprefixとしても使用
     */
    id: {
      type: String,
      default: 'place-option-menu',
    },
    /**
     * 追加表示項目
     */
    additionalItems: {
      type: Array,
      default: () => [],
    },
    /**
     * 簡易表示フラグ
     */
    isSimple: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      // メニューツールチップの表示フラグ
      isMenuShow: false,
      // ツールチップの表示フラグ
      isTooltipShow: false,
      // 項目選択モーダルの表示フラグ
      isItemSelectorShow: false,
      // メニューツールチップのオフセット
      // ※メニュー幅（250px）、ボタン幅（32px）
      menuOffset: 250 / 2 - 32 / 2,
    }
  },
  computed: {
    /**
     * ボタン要素ID
     * @type {String}
     */
    buttonId: function () {
      return `${this.id}-button`
    },
  },
}
</script>

<style lang="scss" scoped>
.action-btn {
  @include mixin-button(true);
}

.menu-btn {
  background-color: #ffffff;
}

.menu-popup {
  &.tooltip {
    opacity: 1;
    padding: 8px 0;
    // 非表示トリガーのblurイベントがモーダルの表示後に発生するので
    // モーダルのz-indexより下げてバックドロップの裏に回るようにする
    z-index: 1039;

    ::v-deep .arrow {
      display: none;
    }
    ::v-deep .tooltip-inner {
      width: 250px;
      max-width: initial;
      border-radius: $border-radius-small;
      background-color: #ffffff;
      padding: 0;
      box-shadow: $drop-shadow-middle;
      text-align: left;
    }
  }
}
</style>
